import type { FC } from "react";
import { Banner, BannerType } from "@stubhub/broadway-web";
import { PersonOutlineIcon } from "@stubhub/broadway-web/icons/functional";
import type { ISiteMessage } from "src/http/types";
import { useTracking } from "src/shared/hooks";

interface Props {
  numberOfPeopleViewedMessage?: ISiteMessage;
}

const defaultNumberOfPeopleViewedMessage: Props["numberOfPeopleViewedMessage"] = {};

export const PeopleViewedBanner: FC<Props> = ({ numberOfPeopleViewedMessage = defaultNumberOfPeopleViewedMessage }) => {
  useTracking(numberOfPeopleViewedMessage.featureTrackingKey);
  const { message, qualifier } = numberOfPeopleViewedMessage;

  return (
    <Banner type={BannerType.Info} icon={PersonOutlineIcon}>
      {message} {qualifier}
    </Banner>
  );
};
